module.exports = __webpack_public_path__ + "img/map-location.aa56bbe.svg";